module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Dress-21092fcfe545d262fac40936cf48a445.svg";